import React, { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route } from "react-router-dom";
import { Backdrop, Container, Snackbar, SnackbarContent, createTheme, useMediaQuery } from "@mui/material";
import { colors } from "../../theme/index.js";
import PrimarySearchAppBar from "../AppBar/AppBar";
import "./App.css";
import Channel from "../../pages/Channel/Channel";
import { PAGE_ROUTES, ROUTES_PATH, STATIC_PAGES } from "../../utils/constants";
import CreateChannel from "../../pages/Channel/CreateChannel";
import Home from "../../pages/Home";
import { getUserDetails } from "../../services/APIServices/user.api";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getUser, setUser } from "../../store/reducers/user.reducer";
import { BottomNav } from "../Drawer/Drawer";
import { isMobile } from "react-device-detect";
import SearchPage from "../../pages/Search/Search";
import ChannelProfile from "../../pages/Channel/ChannelProfile";
import { WatchPage } from "../../pages/WatchPage";
import UploadVideo from "../UploadVideo/UploadVideo";
import { grey } from "@mui/material/colors";
import Login from "../../pages/Login";
import UserSignup from "../../pages/UserSignup/UserSignup";
import UserLogin from "../../pages/UserLogin/UserLogin";
import ForgotPassword from "../../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../../pages/ResetPassword/ResetPassword";
import VerifyUser from "../../pages/VerifyUser/VerifyUser";
import { AuthProvider } from "../../context/AuthContext";
import Profile from "../../pages/Profile/Profile";
import { getMessage, setMessage } from "../../store/reducers/message.reducer";
import CircularProgressWithLabel from "../Progress/CircularProgressWithLabel";
import { getLoading, setLoading } from "../../store/reducers/loading.reducer";
import Shorts from "../../pages/Shorts/Shorts.tsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShortContainer from "../../pages/Shorts/ShortContainer.jsx";
import DeleteAccount from "../../pages/DeleteAccount/DeleteAccount.tsx";
import Subscriptions from "../../pages/Subscriptions/Subscriptions.tsx";
import ContactUs from "../../pages/ContactUs/ContactUs.tsx";
import WatchPageRouter from "../../pages/WatchPageRouter/WatchPageRouter.tsx";
import MobileProfilePage from "../../pages/Profile/MobileProfilePage.tsx";
import BlockedChannels from "../../pages/BlockedChannels/BlockedChannels.tsx";
import BlockedVideos from "../../pages/BlockedVideos/BlockedVideos.tsx";
import InstallPopop from "../../pages/InstallPopup/InstallPopup.tsx";
import About from "../../pages/About/About.tsx";
import PrivacyPolicy from "../../pages/PrivacyPolicy/PrivacyPolicy.tsx";
import TermsOfService from "../../pages/TermsOfService/TermsOfService.tsx";
import Contact from "../../pages/Contact/Contact.tsx";
import DMCA from "../../pages/DMCA/DMCA.tsx";
import Blog from "../../pages/Blog/Blog.tsx";
import HowToUploadVideos from "../../pages/Blog/posts/HowToUploadVideos.tsx";
import VideoGuidelines from "../../pages/Blog/posts/VideoGuidelines.tsx";
import IndianCreators from "../../pages/Blog/posts/IndianCreators.tsx";
import VideoMonetization from "../../pages/Blog/posts/VideoMonetization.tsx";
import CommunityRules from "../../pages/Blog/posts/CommunityRules.tsx";
// New Blog Posts - Creator Guides
import GrowYourChannel from "../../pages/Blog/posts/GrowYourChannel.tsx";
import VideoEditingTools from "../../pages/Blog/posts/VideoEditingTools.tsx";
import EngagingThumbnails from "../../pages/Blog/posts/EngagingThumbnails.tsx";
import VideoSEOTips from "../../pages/Blog/posts/VideoSEOTips.tsx";
import PersonalBrand from "../../pages/Blog/posts/PersonalBrand.tsx";
import MonetizationStrategies from "../../pages/Blog/posts/MonetizationStrategies.tsx";
import CopyrightFairUse from "../../pages/Blog/posts/CopyrightFairUse.tsx";
import ViralShortContent from "../../pages/Blog/posts/ViralShortContent.tsx";
import UnderstandingAnalytics from "../../pages/Blog/posts/UnderstandingAnalytics.tsx";
import CollaborationTips from "../../pages/Blog/posts/CollaborationTips.tsx";
// New Blog Posts - Viewer Guides
import DiscoverContent from "../../pages/Blog/posts/DiscoverContent.tsx";
import ManageSubscriptions from "../../pages/Blog/posts/ManageSubscriptions.tsx";
import HiddenFeatures from "../../pages/Blog/posts/HiddenFeatures.tsx";
import ReportContent from "../../pages/Blog/posts/ReportContent.tsx";
import ParentalControls from "../../pages/Blog/posts/ParentalControls.tsx";
// New Blog Posts - Platform News
import IndeeClipsVsYouTube from "../../pages/Blog/posts/IndeeClipsVsYouTube.tsx";
import FutureDigitalContent from "../../pages/Blog/posts/FutureDigitalContent.tsx";
import Roadmap2026 from "../../pages/Blog/posts/Roadmap2026.tsx";
import BehindTheScenes from "../../pages/Blog/posts/BehindTheScenes.tsx";
import SuccessStories from "../../pages/Blog/posts/SuccessStories.tsx";
// New Blog Posts - Industry Insights
import RegionalLanguageContent from "../../pages/Blog/posts/RegionalLanguageContent.tsx";
import StreamingTechnology from "../../pages/Blog/posts/StreamingTechnology.tsx";
import RecommendationAlgorithms from "../../pages/Blog/posts/RecommendationAlgorithms.tsx";
import InternetTrendsIndia from "../../pages/Blog/posts/InternetTrendsIndia.tsx";
import FreeVideoPlatforms from "../../pages/Blog/posts/FreeVideoPlatforms.tsx";
// Help Center
import Help from "../../pages/Help/Help.tsx";
import CreatingAccount from "../../pages/Help/articles/CreatingAccount.tsx";
import SettingUpProfile from "../../pages/Help/articles/SettingUpProfile.tsx";
import UnderstandingHomepage from "../../pages/Help/articles/UnderstandingHomepage.tsx";
import SearchingVideos from "../../pages/Help/articles/SearchingVideos.tsx";
import WatchingVideos from "../../pages/Help/articles/WatchingVideos.tsx";
import SubscribingChannels from "../../pages/Help/articles/SubscribingChannels.tsx";
import WatchHistory from "../../pages/Help/articles/WatchHistory.tsx";
import BlockingContent from "../../pages/Help/articles/BlockingContent.tsx";
import ReportingContent from "../../pages/Help/articles/ReportingContent.tsx";
import CreatingChannel from "../../pages/Help/articles/CreatingChannel.tsx";
import UploadingVideos from "../../pages/Help/articles/UploadingVideos.tsx";
import UploadingClips from "../../pages/Help/articles/UploadingClips.tsx";
import ContentGuidelines from "../../pages/Help/articles/ContentGuidelines.tsx";
import ChannelAnalytics from "../../pages/Help/articles/ChannelAnalytics.tsx";
import ManagingVideos from "../../pages/Help/articles/ManagingVideos.tsx";
import ChangingPassword from "../../pages/Help/articles/ChangingPassword.tsx";
import UpdatingProfile from "../../pages/Help/articles/UpdatingProfile.tsx";
import DeletingAccount from "../../pages/Help/articles/DeletingAccount.tsx";
// FAQ
import FAQ from "../../pages/FAQ/FAQ.tsx";

export const ColorModeContext = React.createContext({
    toggleColorMode: () => {},
    setMode: () => {},
    currentMode: "system",
});

function App({ initialData = {} }) {
    let dispatch = useAppDispatch();
    const user = useAppSelector((state) => getUser(state));
    const message = useAppSelector((state) => getMessage(state));
    const { isLoading, progress } = useAppSelector((state) => getLoading(state));
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const [mode, setMode] = React.useState(
        typeof window !== 'undefined' ? (localStorage.getItem("themeMode") || "system") : "system"
    );

    const appliedMode = React.useMemo(() => {
        if (mode === "system") {
            return prefersDarkMode ? "dark" : "light";
        }
        return mode;
    }, [mode, prefersDarkMode]);

    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
            },
            setMode: (newMode) => {
                setMode(newMode);
            },
            currentMode: mode,
        }), [mode]
    );

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem("themeMode", mode);
        }
    }, [mode]);

    const theme = React.useMemo(
        () =>
        createTheme({
            palette: {
                mode: appliedMode,
                ...(appliedMode === 'light' ? {
                    // palette values for light mode
                    primary: { main: colors.blueDark },
                    text: {
                        primary: grey[900],
                        secondary: grey[800],
                    },
                    secondary: {
                        main: colors.orangeDark,
                    },
                } : {
                    // palette values for dark mode
                    primary: { main: colors.blueDark },
                    secondary: {
                        main: colors.orangeDark,
                    },
                    text: {
                        primary: '#fff',
                        secondary: grey[500],
                    },
                }),
            },
        }), [appliedMode],
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const isMobile = window.innerWidth <= 768;
        localStorage.setItem("isMobile", isMobile ? "true" : "false");

        const handleResize = () => {
            localStorage.setItem("isMobile", window.innerWidth <= 768 ? "true" : "false");
        };
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return ( <
            div className = "App" >
            <
            ColorModeContext.Provider value = { colorMode } >
            <
            ThemeProvider theme = { theme } > {
                isLoading ?
                <
                Backdrop
                sx = {
                    { color: '#fff', zIndex: 10000 }
                }
                open = { isLoading } >
                <
                CircularProgressWithLabel value = { progress }
                /> < /
                Backdrop > : null
            } <
            Container maxWidth = { "xl" }
            sx = {
                { paddingTop: 10, paddingLeft: 0, paddingRight: 0 }
            } >
            <
            ToastContainer / >
            <
            AuthProvider >
            <
            PrimarySearchAppBar / >
            <
            InstallPopop / >
            <
            Container maxWidth = { isMobile ? 'xl' : 'lg' }
            sx = {
                { paddingBottom: 8, paddingLeft: isMobile ? 0 : 'initial', paddingRight: isMobile ? 0 : 'initial' }
            } >
            <
            Routes >
            <
            Route path = "/"
            element = { < Home initialData = { initialData } / > }
            /> <
            Route path = { ROUTES_PATH.CHANNEL_LANDING }
            element = { < Channel / > }
            /> <
            Route path = { ROUTES_PATH.CHANNEL_PROFILE } >
            <
            Route path = ":channelID"
            element = { < ChannelProfile / > }
            /> < /
            Route > <
            Route path = { '/video/upload' }
            element = { < UploadVideo / > }
            /> <
            Route path = { ROUTES_PATH.CREATE_CHANNEL }
            element = { < CreateChannel / > }
            /> <
            Route path = { ROUTES_PATH.SEARCH }
            element = { < SearchPage / > }
            /> <
            Route path = { ROUTES_PATH.PLAYER }
            element = { < WatchPageRouter initialData = { initialData } / > }
            /> <
            Route path = { PAGE_ROUTES.MORE_OPTIONS_PAGE }
            element = { < MobileProfilePage / > }
            /> <
            Route path = { ROUTES_PATH.LOGIN }
            element = { < UserLogin redirectRequired = { true }
                />} / >
                <
                Route
                path = { '/usersignup' }
                element = { < UserSignup / > }
                /> <
                Route
                path = { '/forgotpassword' }
                element = { < ForgotPassword redirectRequired = { true }
                    />} / >
                    <
                    Route
                    path = { '/resetpassword' }
                    element = { < ResetPassword redirectRequired = { true }
                        />} / >
                        <
                        Route
                        path = { '/verifyuser' }
                        element = { < VerifyUser / > }
                        /> <
                        Route
                        path = { '/profile' }
                        element = { < Profile / > }
                        />  <
                        Route path = { '/delete-account' }
                        element = { < DeleteAccount / > }
                        /> <
                        Route path = { '/contact-us' }
                        element = { < ContactUs / > }
                        /> <
                        Route path = { '/subscriptions' }
                        element = { < Subscriptions / > }
                        /> <
                        Route path = { '/clips' }
                        element = { < ShortContainer / > }
                        />  <
                        Route path = { '/clips/channel/:channelID/:videoID' }
                        element = { < ShortContainer / > }
                        />  <
                        Route path = { '/clips/share/:videoID' }
                        element = { < ShortContainer / > }
                        /> <
                        Route path = { '/clips/:videoID' }
                        element = { < ShortContainer / > }
                        /> <
                        Route path = { '/blocked-channels' }
                        element = { < BlockedChannels / > }
                        /> <
                        Route path = { '/blocked-videos' }
                        element = { < BlockedVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.ABOUT }
                        element = { < About / > }
                        /> <
                        Route path = { STATIC_PAGES.PRIVACY_POLICY }
                        element = { < PrivacyPolicy / > }
                        /> <
                        Route path = { STATIC_PAGES.TERMS_OF_SERVICE }
                        element = { < TermsOfService / > }
                        /> <
                        Route path = { STATIC_PAGES.CONTACT }
                        element = { < Contact / > }
                        /> <
                        Route path = { STATIC_PAGES.DMCA }
                        element = { < DMCA / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG }
                        element = { < Blog / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_UPLOAD }
                        element = { < HowToUploadVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_GUIDELINES }
                        element = { < VideoGuidelines / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_CREATORS }
                        element = { < IndianCreators / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_MONETIZATION }
                        element = { < VideoMonetization / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_COMMUNITY }
                        element = { < CommunityRules / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_GROW_CHANNEL }
                        element = { < GrowYourChannel / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_EDITING_TOOLS }
                        element = { < VideoEditingTools / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_THUMBNAILS }
                        element = { < EngagingThumbnails / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_VIDEO_SEO }
                        element = { < VideoSEOTips / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_PERSONAL_BRAND }
                        element = { < PersonalBrand / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_MONETIZATION_STRATEGIES }
                        element = { < MonetizationStrategies / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_COPYRIGHT }
                        element = { < CopyrightFairUse / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_VIRAL_SHORTS }
                        element = { < ViralShortContent / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_ANALYTICS }
                        element = { < UnderstandingAnalytics / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_COLLABORATION }
                        element = { < CollaborationTips / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_DISCOVER }
                        element = { < DiscoverContent / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_MANAGE_SUBS }
                        element = { < ManageSubscriptions / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_HIDDEN_FEATURES }
                        element = { < HiddenFeatures / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_REPORT }
                        element = { < ReportContent / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_PARENTAL }
                        element = { < ParentalControls / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_VS_YOUTUBE }
                        element = { < IndeeClipsVsYouTube / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_FUTURE_CONTENT }
                        element = { < FutureDigitalContent / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_ROADMAP }
                        element = { < Roadmap2026 / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_BEHIND_SCENES }
                        element = { < BehindTheScenes / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_SUCCESS_STORIES }
                        element = { < SuccessStories / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_REGIONAL_LANGUAGE }
                        element = { < RegionalLanguageContent / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_STREAMING_TECH }
                        element = { < StreamingTechnology / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_ALGORITHMS }
                        element = { < RecommendationAlgorithms / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_INTERNET_TRENDS }
                        element = { < InternetTrendsIndia / > }
                        /> <
                        Route path = { STATIC_PAGES.BLOG_PLATFORM_ECONOMICS }
                        element = { < FreeVideoPlatforms / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP }
                        element = { < Help / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_CREATING_ACCOUNT }
                        element = { < CreatingAccount / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_SETTING_UP_PROFILE }
                        element = { < SettingUpProfile / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_UNDERSTANDING_HOMEPAGE }
                        element = { < UnderstandingHomepage / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_SEARCHING_VIDEOS }
                        element = { < SearchingVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_WATCHING_VIDEOS }
                        element = { < WatchingVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_SUBSCRIBING }
                        element = { < SubscribingChannels / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_WATCH_HISTORY }
                        element = { < WatchHistory / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_BLOCKING }
                        element = { < BlockingContent / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_REPORTING }
                        element = { < ReportingContent / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_CREATING_CHANNEL }
                        element = { < CreatingChannel / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_UPLOADING_VIDEOS }
                        element = { < UploadingVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_UPLOADING_CLIPS }
                        element = { < UploadingClips / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_CONTENT_GUIDELINES }
                        element = { < ContentGuidelines / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_CHANNEL_ANALYTICS }
                        element = { < ChannelAnalytics / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_MANAGING_VIDEOS }
                        element = { < ManagingVideos / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_CHANGING_PASSWORD }
                        element = { < ChangingPassword / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_UPDATING_PROFILE }
                        element = { < UpdatingProfile / > }
                        /> <
                        Route path = { STATIC_PAGES.HELP_DELETING_ACCOUNT }
                        element = { < DeletingAccount / > }
                        /> <
                        Route path = { STATIC_PAGES.FAQ }
                        element = { < FAQ / > }
                        /> < /
                        Routes > < /
                        Container > { isMobile ? < BottomNav / > : null } <
                        /AuthProvider> {
                            message ? < Snackbar
                            autoHideDuration = { 6000 }
                            anchorOrigin = {
                                { vertical: 'top', horizontal: 'center' }
                            }
                            open = { true }
                            onClose = {
                                () => dispatch(setMessage(null))
                            } >
                            <
                            SnackbarContent message = { message }
                            /> < /
                            Snackbar > : null
                        } <
                        /Container> < /
                        ThemeProvider > <
                        /ColorModeContext.Provider> < /
                        div >
                    );
                }

                export default App;